const INO_API_BASE = `${process.env.NEXT_PUBLIC_INO_BASE_URL}${
  process.env.NEXT_PUBLIC_BUILD_ENV === 'PRODUCTION' ? '/api-v2' : '/api'
}` as string;

export default INO_API_BASE;
